import { BillingPlanMetric } from '../metrics/BillingPlanMetric';

export class CompiledDailyEngagedUserConsumption extends BillingPlanMetric {
  constructor(compiledDailyEngagedUserConsumption: Partial<CompiledDailyEngagedUserConsumption | null>) {
    super(compiledDailyEngagedUserConsumption);
    Object.assign(this, compiledDailyEngagedUserConsumption);
  }
}
